export const APP_ID_LENGTH = 16;
export const INTERNAL_QR_CODE_URL_BASE = "mini://platformapi/startapp?_ariver_appid=";
export const PROD_URL_BASE = "https://app.adjust.com/jau3fuy?deep_link=vodapaywallet%3A%2F%2Fdeeplink.htm%3F";
export const SANDBOX_URL_BASE = "https://app.adjust.com/30q9i84?deep_link=vodapaywallet%3A%2F%2Fdeeplink.htm%3F";
export const VODAPAY_URL_SCHEME = "vodapaywallet://deeplink.htm?";